import { Account } from '../interfaces/Account';

export const getAccountDisplayName = (account: Account): string | null => {
  if (!account) {
    return null;
  }

  return account.displayName ? account.displayName : account.name;
};
